// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal--wrapper[data-v-7f37971b]{padding:0}.close[data-v-7f37971b]{display:none}", ""]);
// Exports
module.exports = exports;
